import * as queries from './queries';
import app from '../../app';

export const getEnabledModules = async function ({ dispatch, commit, state }) {
    // If enabled modules were already fetched, no need to fetch again. Will only change on new deploys.
    if (state.modules.length){
        return state.modules;
    }

    try {
        const { data, errors } = await app.apolloMobileClient.query({
            query: queries.getEnabledModules
        })

        if (data && ! errors) {
            commit('set', data.behaviourComponents)
            return data;
        } else if (errors.length) {
            errors.forEach((error) => {
                dispatch('error/submit', error, { root: true });
            })
        }

        return false;
    } catch (error) {
        dispatch('error/submit', error, { root: true });
        return false;
    }
};